/** Fixed interval strategy for the Modified British System grid: 100 km major, 20 km minor. */
export class MBSIntervals {
    getInterval(_resolution, _viewProjection) {
        return 100_000;
    }
    getMinorInterval(_majorInterval) {
        return 20_000;
    }
}
//# sourceMappingURL=MBSIntervals.js.map